import { type ComponentType } from "react";
import { createRoot } from "react-dom/client";

import { FAQ } from "./components/FAQ.js";
import { Glossary } from "./components/Glossary.js";
import type { targets } from "./rtfaqs-front.js";
import type { FAQProps } from "./types.js";
import { datasetSchema } from "./types.js";

const components: {
	[key in (typeof targets)[number]["selector"]]: {
		Component: ComponentType<FAQProps>;
	};
} = {
	"[data-faq='glossary']": { Component: Glossary },
	"[data-faq='normal']": { Component: FAQ },
};

/** Loops through known selectors and mounts their elements if present. */
export default function (): void {
	for (const [selector, definition] of Object.entries(components)) {
		const element = document.querySelector(selector);
		if (!(element instanceof HTMLDivElement)) continue;
		const data = datasetSchema.parse(element);

		const root = createRoot(element);
		root.render(<definition.Component {...data} />);
	}
}
